export default __webpack_public_path__ + "static/media/plain-sticker-C.cb92a011.png";